/** Porter tow jobs (#1316). A separate resource from bookings; booking routes are unchanged. */
export class TowJobsClient {
    request;
    constructor(request) {
        this.request = request;
    }
    base(slug, id) {
        const b = `/v1/sites/${encodeURIComponent(slug)}/tow-jobs`;
        return id === undefined ? b : `${b}/${encodeURIComponent(id)}`;
    }
    /** Public (no sign-in): a customer or the front desk asks for a tow. */
    create(slug, input) {
        return this.request("POST", this.base(slug), input);
    }
    /** business:write lists every job; `mine: true` lists the caller's own open jobs (porters). */
    async list(slug, opts = {}) {
        const q = opts.mine ? "?mine=true" : "";
        const res = await this.request("GET", `${this.base(slug)}${q}`, undefined, true);
        return res.towJobs;
    }
    get(slug, id) {
        return this.request("GET", this.base(slug, id), undefined, true);
    }
    /** business:write. The user must be an active porter of the site. */
    assign(slug, id, userId) {
        return this.request("POST", `${this.base(slug, id)}/assign`, { userId }, true);
    }
    /** The assigned porter (or business:write) records picked_up, then delivered. */
    complete(slug, id, step) {
        return this.request("POST", `${this.base(slug, id)}/complete`, { step }, true);
    }
    cancel(slug, id) {
        return this.request("POST", `${this.base(slug, id)}/cancel`, undefined, true);
    }
    linkOrder(slug, id, orderId) {
        return this.request("POST", `${this.base(slug, id)}/link-order`, { orderId }, true);
    }
}
//# sourceMappingURL=towJobs.js.map